export default __webpack_public_path__ + "static/okami-0ab5aa418cc3040b31a369b76b8bc472.png";